import { z } from "zod";
const CourseClassificationQuery = z.array(z.object({
    Id: z.number(),
    CourseType: z.string(),
}));

export { CourseClassificationQuery };
